angular.module('app.notfound', [])

  .component('notFound', {
    templateUrl: '/partials/notfound/error-404.html',
    controller: class NotFound {
      /* @ngInject */
      constructor(FEATURE_CONFIG, $window) {
        this.carHireOrigin = R.pathOr('', ['Origin'], FEATURE_CONFIG.CAR_HIRE_AEM);
        this.roomsOrigin = $window.ROOMS_V2_FE;
      }
    }
  });
